import { SerializableObject } from '../../common-react/core';

import { SearchResultSet } from './search-result-set.do';

export class GlobalSearchResults extends SerializableObject {
    resultSets: SearchResultSet[];
}
